import React from 'react'
import ParentStyles from '../../styles'
import Styles from './styles'
import Switch from '../Switch'
import conversationSVG from '~/assets/img/svg/conversation.svg'
import { Star } from 'react-feather'
import { FormattedMessage, useIntl } from 'react-intl'
import getNumber from '~/helpers/getNumber'
import { useSearchParamsHandler } from '~/contexts/FilterContext'
import { Spinner } from 'reactstrap'

export default function ReviewSection({
  reviewsReceived = 0,
  reviewsAnswered = 0,
  reviewsStarsAvg = 0,
  reviewsPorcentage = 0,
  onChange = () => {},
  success = false,
  loading = false,
}) {
  const intl = useIntl()
  const { query } = useSearchParamsHandler()
  const { reviews_period } = query
  const handleSwitchChange = value => {
    onChange(value)
  }

  if (!success) {
    return null
  }
  return (
    <ParentStyles.Box>
      <Styles.Head>
        <ParentStyles.Title>
          <FormattedMessage id={'Reviews'} />
        </ParentStyles.Title>
        <Styles.SwitchWrapper>
          <span>
            <FormattedMessage id={'homeReviewsToggle.last'} />:
          </span>
          <Switch
            options={['7D', '1M']}
            value={reviews_period}
            onChange={handleSwitchChange}
          />
        </Styles.SwitchWrapper>
      </Styles.Head>
      {loading && (
        <Spinner
          style={{
            alignSelf: 'center',
          }}
        />
      )}

      {!loading && (
        <>
          <Styles.StatsWrapper>
            <ParentStyles.Box
              alignItems={'center'}
              padding={'16px'}
              gap={'16px'}
              flexDirection={'row'}
              flex="1 0 auto"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="68"
                height="69"
                viewBox="0 0 68 69"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M34 68.5352C52.7777 68.5352 68 53.3128 68 34.5352C68 15.7575 52.7777 0.535156 34 0.535156C15.2223 0.535156 0 15.7575 0 34.5352C0 53.3128 15.2223 68.5352 34 68.5352Z"
                  fill="#FFFBF0"
                />
                <path
                  d="M34.4659 25.6855L37.3443 31.5168L43.781 32.4576L39.1235 36.994L40.2227 43.4028L34.4659 40.3754L28.7092 43.4028L29.8084 36.994L25.1509 32.4576L31.5876 31.5168L34.4659 25.6855Z"
                  stroke="#4A5568"
                  strokeWidth="1.86301"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <Styles.StatsBox>
                <Styles.StatsBoxTitle>
                  <FormattedMessage id={'homeReviewsReceivedTitle'} />
                </Styles.StatsBoxTitle>
                <Styles.StatsBoxValue>
                  {getNumber.LocaleNumber(reviewsReceived, intl.locale)}
                </Styles.StatsBoxValue>
                <div className="star-box">
                  <Star fill={'#FFA84C'} stroke={'#FFA84C'} size={17} />
                  <span>
                    {intl
                      .formatMessage({ id: 'homeReviewsAvg' })
                      .replace(
                        '{{count}}',
                        getNumber.LocaleNumber(reviewsStarsAvg, intl.locale)
                      )}
                  </span>
                </div>
              </Styles.StatsBox>
            </ParentStyles.Box>
            <ParentStyles.Box
              alignItems={'center'}
              padding={'16px'}
              gap={'16px'}
              flexDirection={'row'}
              flex="1 0 auto"
            >
              <img src={conversationSVG} alt="conversas" />
              <Styles.StatsBox>
                <Styles.StatsBoxTitle>
                  <FormattedMessage id="Replied reviews" />
                </Styles.StatsBoxTitle>
                <Styles.StatsBoxValue>
                  {getNumber.LocaleNumber(reviewsAnswered, intl.locale)}
                </Styles.StatsBoxValue>
              </Styles.StatsBox>
            </ParentStyles.Box>
          </Styles.StatsWrapper>
          <ParentStyles.Box gap={'16px'} background={'#F3FFF9'}>
            <Styles.CustomTitle>
              <FormattedMessage
                id={`homeReviewsToggle.${reviews_period}.description`}
              />
              :
            </Styles.CustomTitle>
            <Styles.ProgressBar percent={reviewsPorcentage}>
              <div className="custom-progress">
                <span>
                  {getNumber.LocaleNumber(reviewsPorcentage, intl.locale)}%
                </span>
              </div>
            </Styles.ProgressBar>
          </ParentStyles.Box>
          <a href="/reviews">
            <ParentStyles.BlackButton>
              <FormattedMessage id={'homeReviewsButton'} />
            </ParentStyles.BlackButton>
          </a>
        </>
      )}
    </ParentStyles.Box>
  )
}
